import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ONYX_TABLE_TOOLTIP_DELAY,
  OnyxAddressComponent,
  OnyxLinkComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { DriverHelper } from '../../../../dashboard/drivers/common/helpers/driver.helper';
import type { Driver } from '../../../../dashboard/drivers/common/interfaces/driver';
import { FleetHelper } from '../../../../dashboard/fleet/common/helpers/fleet.helper';
import { FleetTypeHelper } from '../../../../dashboard/fleet/common/helpers/fleet-type.helper';
import type { Fleet } from '../../../../dashboard/fleet/common/interfaces/fleet';
import type { SimplifiedBase } from '../../../../dashboard/management-panel/bases/common/interfaces/base';

@Component({
  selector: 'app-base-cell',
  imports: [
    OnyxAddressComponent,
    OnyxLinkComponent,
    TranslatePipe,
    OnyxTooltipDirective,
  ],
  templateUrl: './base-cell.component.html',
  styleUrl: './base-cell.component.scss',
})
export class BaseCellComponent {
  private readonly fleetHelper = inject(FleetHelper);
  private readonly driverHelper = inject(DriverHelper);

  public readonly base = input.required<SimplifiedBase | null>();
  public readonly vehicle = input(null, {
    transform: (vehicle: Fleet | null) => {
      if (!vehicle) return null;
      if (!FleetTypeHelper.isVehicle(vehicle)) return null;
      return vehicle;
    },
  });
  public readonly driver = input<Driver | null>(null);

  protected readonly I18N = 'fleet.fleetList.cells';
  protected readonly TOOLTIP_DELAY = ONYX_TABLE_TOOLTIP_DELAY;

  protected isArchived = computed(() => {
    const [vehicle, driver] = [this.vehicle(), this.driver()];
    if (vehicle) {
      return FleetHelper.isArchived(vehicle);
    } else if (driver) {
      return DriverHelper.isArchived(driver);
    }
    return false;
  });

  protected assignBase(): void {
    const [vehicle, driver] = [this.vehicle(), this.driver()];
    if (vehicle) {
      this.fleetHelper.edit(vehicle.uuid, {});
    } else if (driver) {
      this.driverHelper.edit(driver.uuid, {});
    }
  }
}
